import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  IconButton,
  Grid,
  Button,
  useTheme,
  alpha,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const formatDateTime = (dateString) => {
  if (!dateString) return "N/A";
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  return new Date(dateString).toLocaleDateString(undefined, options);
};
function ViewRBMException({ open, onClose, exception }) {
  const theme = useTheme();
  if (!exception) return null;
  const detailFields = [
    {
      label: "Employee ID",
      value: exception.employeeId,
      color: "#f59e0b",
    },
    {
      label: "Institution",
      value: exception.Institution,
      color: "#8b5cf6", 
    },
    {
      label: "Position",
      value: exception.Position,
      color: "#06b6d4",
    },
    {
      label: "Granted Action",
      value: exception.action,
      color: "#10b981", 
    },
        {
      label: "Fiscal Year",
      value: exception.FiscalYear,
      color: "#3b82f6", 
    },
        {
      label: "Quarter",
      value: exception.QuarterName,
      color: "#10b981", 
    },
    {
      label: "Grace Period",
      value: exception.gracePeriodDays ? `${exception.gracePeriodDays} Days` : "N/A",
      color: "#ec4899", 
    },
    {
      label: "Start Date",
      value: formatDateTime(exception.startDate),
      color: "#6366f1",
    },
    {
      label: "End Date",
      value: formatDateTime(exception.endDate),
      color: "#ef4444", 
    },
    {
      label: "Opened By",
      value: exception.OpenedBy,
      color: "#64748b", 
    },
  ];
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "16px",
          },
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        }}
    >
      {/* HEADER */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          p: 3,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: "white",
            fontWeight: 600,
          }}
        >
          Exception Details - {exception.employee_name}
        </Typography>

        <IconButton
          onClick={onClose}
          sx={{
            color: "white",
            bgcolor: "rgba(255, 255, 255, 0.1)",
            "&:hover": {
              bgcolor: "rgba(255, 255, 255, 0.2)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {/* CONTENT */}
      <DialogContent sx={{ p: 4, bgcolor: "#fcfcfc" }}>
        <Typography
          variant="subtitle2"
          sx={{ mb: 3, color: "text.secondary", fontWeight: 500 }}
        >
          Information regarding the exception granted to the employee.
        </Typography>

        {/* Data Grid Cards */}
        <Grid container spacing={2}>
          {detailFields.map((field, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                sx={{
                  bgcolor: "background.paper",
                  borderRadius: 2,
                  p: 2,
                  border: "1px solid rgba(0, 0, 0, 0.08)",
                  transition: "all 0.2s",
                  height: "100%",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                  "&:hover": {
                    borderColor: field.color,
                    boxShadow: `0 4px 12px ${alpha(field.color, 0.15)}`,
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1 }}>
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      bgcolor: field.color,
                      flexShrink: 0,
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      color: "text.secondary",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                    }}
                  >
                    {field.label}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontSize: "0.95rem",
                    color: "text.primary",
                    fontWeight: 500,
                    wordBreak: "break-word",
                  }}
                >
                  {field.value || "—"}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* Action Buttons */}
        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              px: 4,
              py: 1,
              borderColor: alpha(theme.palette.text.primary, 0.2),
              color: "text.primary",
              "&:hover": {
                backgroundColor: alpha(theme.palette.text.primary, 0.05),
                borderColor: alpha(theme.palette.text.primary, 0.3),
              },
            }}
          >
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ViewRBMException;